// @flow

import { observer } from "mobx-react";
import React from "react";

import GlobalSettingsStore from "app/stores/GlobalSettingsStore";
import UserStore from "app/stores/UserStore";

import Video from "app/models/Video";

import AnimatedIconLoading from "app/components/AnimatedIconLoading/AnimatedIconLoading";
import VideoCards from "app/components/VideoCards/VideoCards";
// import VideoCard from "app/components/VideoCard/VideoCard";
// import CreateStory from "app/components/CreateStory/CreateStory";

import "./NewVideoView.scss";

type Props = {
    existingVideos: any,
    newVideo: any,
    serverTime: any
};

type State = {
    requestedEarlyAccess: boolean,
    loadingEarlyAccess: boolean
};

@observer
export default class NewVideoView extends React.Component<Props, State> {
    existingVideos: Video[];
    newVideo: Video;
    newVideoCreatedBy: ?string;

    constructor(props: Props) {
        super(props);

        const user = UserStore.user || {};
        this.state = {
            requestedEarlyAccess: user.requested_early_access,
            loadingEarlyAccess: false
        };

        this.existingVideos = Video.makeArray(this.props.existingVideos);

        const newVideo = Video.make(this.props.newVideo);
        if (!newVideo) throw new Error("newVideo must not be null/undefined");
        this.newVideo = newVideo;

        this.newVideoCreatedBy = newVideo.created_by;

        newVideo.available = true;
        newVideo.created_by = user.id;
        newVideo.author_image = user.profile_image;
        newVideo.author_name = user.name;
        newVideo.author_username = user.username;
        newVideo.author_slug = user.profile_slug;
    }

    get cardTheme(): string {
        return GlobalSettingsStore.videoCardTheme;
    }

    handleRequestEarlyAccess = () => {
        this.setState({ loadingEarlyAccess: true });
        UserStore.requestEarlyAccess().then(
            () => {
                this.setState({
                    requestedEarlyAccess: true,
                    loadingEarlyAccess: false
                });
            },
            () => {
                this.setState({ loadingEarlyAccess: false });
            }
        );
    };

    render() {
        return (
            <div className="NewVideoView">
                <div className="container">{this.renderColumns()}</div>
            </div>
        );
    }

    renderColumns() {
        if (!this.existingVideos.length) {
            return this.renderSingleColumn();
        }

        return this.renderMultiColumn();
    }

    renderNewCardOrEarlyAccess() {
        if (GlobalSettingsStore.requireEarlyAccess) {
            const user = UserStore.user;
            if (!user || !user.early_access) {
                return this.renderRequireEarlyAccess();
            }
        }
        return this.renderNewCard();
    }

    renderRequireEarlyAccess() {
        return (
            <div className="NewVideoView__requireEarlyAccess">
                <header>
                    <h4>You need early access to create new videos.</h4>
                </header>

                {this.renderEarlyAccessLink()}
            </div>
        );
    }

    renderEarlyAccessLink() {
        const user = UserStore.user;
        if (!user) {
            return (
                <a href="/sign-up" className="NewVideoView__action-button">
                    Sign up
                </a>
            );
        }

        if (this.state.requestedEarlyAccess) {
            return (
                <div>
                    You are in the early access queue. We'll contact you soon
                    with more details
                </div>
            );
        }

        if (this.state.loadingEarlyAccess) {
            return (
                <div>
                    <AnimatedIconLoading /> Publishing
                </div>
            );
        }

        return (
            <button
                className="NewVideoView__action-button"
                type="button"
                onClick={this.handleRequestEarlyAccess}
            >
                Request early access
            </button>
        );
    }

    renderNewCard() {
        // let buttonText;
        // let text = "Create your own video:";
        // let buttonIcon;
        // if (!this.existingVideos.length) {
        //     if (this.newVideoCreatedBy) {
        //         text = "You have an annotated version of this video:";
        //     } else {
        //         text = "Be the first one to annotate this video:";
        //         buttonText = "Create your video story now!";
        //     }
        // } else {
        //     if (this.newVideo.published_at) {
        //         text = "You have a published version of this video:";
        //     } else if (this.newVideoCreatedBy) {
        //         text = "You haven't published your video yet:";
        //     }
        // }
        // if (this.newVideoCreatedBy) {
        //     // buttonIcon = "pencil";
        //     if (!buttonText) {
        //         buttonText = "Edit your video story";
        //     }
        // }

        const classes = ["NewVideoView__new"];
        if (!this.existingVideos.length) {
            classes.push("NewVideoView__new--centered");
        }
        
        const url = `/video/annotate/${this.newVideo.url}`;
        if (UserStore.hasEarlyAccess) {
            window.location.href = url;
        } else {
            window.location.href = "/sign-up";
        }
        return;

        // return (
        //     <div className={classes.join(" ")}>
        //         <h2 className="NewVideoView__title">{text}</h2>
        //         <div className="NewVideoView__new-card">
        //             <VideoCard
        //                 video={this.newVideo}
        //                 serverTime={this.props.serverTime}
        //                 items={this.newVideo.items || []}
        //                 theme={this.cardTheme}
        //                 withoutUrl={true}
        //             />
        //             <CreateStory
        //                 text={buttonText}
        //                 icon={buttonIcon}
        //                 url={this.newVideo.url}
        //             />
        //         </div>
        //     </div>
        // );
    }

    renderSingleColumn() {
        return this.renderNewCardOrEarlyAccess();
    }

    renderMultiColumn() {
        return (
            <div className="row">
                <div className="col-md-5 col-md-push-7">
                    {this.renderNewCardOrEarlyAccess()}
                </div>

                <div className="col-md-2">
                    <div className="NewVideoView__or">OR</div>
                </div>

                <div className="col-md-5 col-md-pull-7">
                    <div className="NewVideoView__existing">
                        <h2 className="NewVideoView__title">
                            Browse existing videos:
                        </h2>

                        <VideoCards
                            videos={this.existingVideos}
                            serverTime={this.props.serverTime}
                            theme={this.cardTheme}
                            breakpointClasses="col-xs-12"
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/views/app/video/NewVideo/NewVideoView.js